<script setup lang="ts">
import { useArticleFont } from "@/common/composables/use-article-font.composable";
import PlaceholderWord from "@/components/inflectionTrainer/PlaceholderWord.vue";
import type { DictsysInflectionSchemeContent } from "@/types/article-formats/dictsys";

interface Props {
  inflection: DictsysInflectionSchemeContent;
  usePrefixBox?: boolean;
  useSuffixBox?: boolean;
}

withDefaults(defineProps<Props>(), {
  usePrefixBox: false,
  useSuffixBox: false
});

const { articleFontClass } = useArticleFont();
</script>

<template>
  <span class="inflection-scheme-cell-placeholder" :class="articleFontClass">
    <template v-if="inflection.prefix">
      <span v-if="usePrefixBox"
        ><PlaceholderWord
          class="inflection-scheme-cell-placeholder__placeholder"
          color="secondary"
          width="28px"
      /></span>
      <span v-else class="inflection-scheme-cell-placeholder__prefix"
        >{{ inflection.prefix }}{{ " " }}</span
      >
    </template>

    <span class="inflection-scheme-cell-placeholder__no-break">
      <PlaceholderWord class="inflection-scheme-cell-placeholder__placeholder" /><template
        v-if="inflection.suffix"
      >
        <span v-if="useSuffixBox"
          >{{ " "
          }}<PlaceholderWord
            class="inflection-scheme-cell-placeholder__placeholder"
            color="primary"
            width="28px"
        /></span>
        <span v-else class="inflection-scheme-cell-placeholder__suffix">{{
          inflection.suffix
        }}</span>
      </template>
    </span>
  </span>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.inflection-scheme-cell-placeholder {
  &__placeholder {
    vertical-align: middle;
  }

  &__prefix {
    color: rgb(@theme-colors[@secondary][base]);
    font-weight: 700;
  }

  &__suffix {
    color: rgb(@theme-colors[@primary][base]);
    font-weight: 700;
  }

  &__no-break {
    white-space: nowrap;
  }
}
</style>
